import * as Types from '../types/types.generated';

import { gql } from '@apollo/client';
import { KeywordTagFieldsFragmentDoc } from './keywordTagFields.generated';
import { FieldsForAttachmentColumnFragmentDoc } from './ColumnRenderers.generated';
import { AttachmentFieldsFragmentDoc } from './attachmentFields.generated';
import { UserFieldsFragmentDoc } from './userFields.generated';
export type RequiredFieldsForParagraphOfParagraphsListFragment = { __typename?: 'RegulatoryDocumentParagraph', id: string, modelYear?: number | null, comprehensive?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, summary?: string | null, level: number, enumeration: string, isFootnote: boolean, position: number, changeInfoType: Types.ChangeInfoType, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, categories: Array<{ __typename?: 'Category', id: string, name: string }>, tags: Array<{ __typename?: 'Tag', name: string }>, elements: Array<{ __typename?: 'RegulatoryDocumentParagraphElement', type: Types.ParagraphElementType, text?: string | null, isHeader: boolean, page: number, bounds?: Array<number> | null, textPosition?: Types.TextPosition | null, asset?: { __typename?: 'BlobRef', uri: any } | null }>, phaseIn?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, phaseOut?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, requirements: Array<{ __typename?: 'Requirement', id: string, name: string }>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, file: { __typename?: 'BlobRef', uri: any }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null };

export type ParagraphFieldsFragment = { __typename?: 'RegulatoryDocumentParagraph', page: number, createdAt?: any | null, modifiedAt?: any | null, id: string, modelYear?: number | null, comprehensive?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, summary?: string | null, level: number, enumeration: string, isFootnote: boolean, position: number, changeInfoType: Types.ChangeInfoType, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, elements: Array<{ __typename?: 'RegulatoryDocumentParagraphElement', type: Types.ParagraphElementType, text?: string | null, isHeader: boolean, page: number, bounds?: Array<number> | null, textPosition?: Types.TextPosition | null, asset?: { __typename?: 'BlobRef', contentType: string, fileName: string, uri: any } | null }>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, comments?: Array<{ __typename?: 'Commentary', id: string, comment?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, faqs?: Array<{ __typename?: 'Faq', id: string, question?: string | null, answer?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, categories: Array<{ __typename?: 'Category', id: string, name: string }>, phaseIn?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, phaseOut?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, requirements: Array<{ __typename?: 'Requirement', id: string, name: string }> };

export const RequiredFieldsForParagraphOfParagraphsListFragmentDoc = gql`
    fragment RequiredFieldsForParagraphOfParagraphsList on RegulatoryDocumentParagraph {
  id
  modelYear
  comprehensive
  dateNewRegistration
  dateNewTypes
  summary
  level
  enumeration
  isFootnote
  position
  changeInfoType
  driveVariants {
    id
    name
  }
  keywords {
    ...KeywordTagFields
  }
  vehicleCategories {
    id
    name
  }
  categories {
    id
    name
  }
  tags {
    name
  }
  elements {
    type
    text
    isHeader
    page
    bounds
    textPosition
    asset {
      uri
    }
  }
  phaseIn {
    date
    status
  }
  phaseOut {
    date
    status
  }
  requirements {
    id
    name
  }
  attachments {
    ...FieldsForAttachmentColumn
  }
}
    ${KeywordTagFieldsFragmentDoc}
${FieldsForAttachmentColumnFragmentDoc}`;
export const ParagraphFieldsFragmentDoc = gql`
    fragment ParagraphFields on RegulatoryDocumentParagraph {
  ...RequiredFieldsForParagraphOfParagraphsList
  page
  createdAt
  createdBy {
    givenName
    id
    mail
    name
    surname
    userPrincipalName
  }
  modifiedAt
  modifiedBy {
    givenName
    id
    mail
    name
    surname
    userPrincipalName
  }
  tags {
    id
  }
  elements {
    asset {
      contentType
      fileName
    }
  }
  attachments {
    ...AttachmentFields
  }
  comments {
    id
    comment
    createdAt
    createdBy {
      ...UserFields
    }
    modifiedAt
    modifiedBy {
      ...UserFields
    }
  }
  faqs {
    id
    question
    answer
    createdAt
    createdBy {
      ...UserFields
    }
    modifiedAt
    modifiedBy {
      ...UserFields
    }
  }
}
    ${RequiredFieldsForParagraphOfParagraphsListFragmentDoc}
${AttachmentFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;